import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Players from './pages/Players';
import PlayerDetails from './pages/PlayerDetails';
import Schedule from './pages/Schedule';
import Sponsors from './pages/Sponsors';
import SponsorshipInfo from './pages/SponsorshipInfo';
import Donate from './pages/Donate';
import Shop from './pages/Shop';
import Admin from './pages/Admin';
import Contact from './pages/Contact';
import KidsCamp from './pages/KidsCamp';
import LiveScores from './pages/LiveScores';
import LoadingScreen from './components/LoadingScreen';
import MaintenancePage from './components/MaintenancePage';
import { useStore } from './data/store';

function App() {
  const [loading, setLoading] = useState(true);
  const [maintenance] = useState(false); // Set to false to disable maintenance mode
  const { fetchData, isLoading, checkSession } = useStore();

  useEffect(() => {
    // Check session on app load
    checkSession();

    // Force title update
    document.title = 'LC Cardinals';

    // Fetch data from Supabase
    fetchData();

    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading || isLoading) {
    return <LoadingScreen />;
  }

  if (maintenance) {
    return <MaintenancePage />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/players" element={<Players />} />
        <Route path="/players/:id" element={<PlayerDetails />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/sponsorship-info" element={<SponsorshipInfo />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/kids-camp" element={<KidsCamp />} />
        <Route path="/live" element={<LiveScores />} />
      </Routes>
    </Router>
  );
}

export default App;